var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.barcodeData && _vm.barcodeData.dataReview.status !== 'Rejected')?_c('DataReview',{attrs:{"current-step":_vm.currentStep}}):_vm._e(),(_vm.barcodeData && _vm.barcodeData.pdfReview.status !== 'Rejected')?_c('PdfReview',{attrs:{"current-step":_vm.currentStep}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }